import HttpService from '@/common/services/HttpService'
import { type UserDTOV3, type UserLandingPageDTOV1, type UserParamsDTOV3 } from '@/common/types/users'
import { type UserSessionDTOV1 } from '@/common/types/session'
import { type UserForAssignment } from '@/agent/types/users'
import { getCurrentKeycloakToken } from '@/common/services/AuthenticationService'

const serviceRootV1 = '/api/v1/users'
const serviceRootV3 = '/api/v3/users'
interface UsersForAssignmentParams {
  skillCodes?: string[]
}

export const getUser = (userId: number) => {
  return HttpService.getData<UserSessionDTOV1>(`${serviceRootV1}/${userId}`)
}

export const getUserMe = () => {
  return HttpService.getData<UserSessionDTOV1>(`${serviceRootV1}/me`)
}

/**
 * @deprecated
 */
export const getUsersForAssignment = ({ skillCodes }: UsersForAssignmentParams): Promise<UserForAssignment[]> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const params: any = {}
  if (skillCodes !== undefined) params.skillCodes = skillCodes.join(',')
  return HttpService.getData<UserForAssignment[]>('/rest/skills/getUsersForAssignmentWithSkillCodes', {
    params,
  })
}

// get user landing page by jwt
export const getUserLandingPage = (): Promise<UserLandingPageDTOV1> => {
  return HttpService.getData<UserLandingPageDTOV1>(`${serviceRootV1}/me/landing-page`, { headers: { 'jwt-access-token': getCurrentKeycloakToken() } })
}

export const fetchUsersV3 = async (
  includeDeactivated: UserParamsDTOV3['include-deactivated'],
  expand: UserParamsDTOV3['expand'],
  include: UserParamsDTOV3['include'],
): Promise<UserDTOV3[]> => {
  return HttpService.getData<UserDTOV3[]>(serviceRootV3, {
    params: {
      'include-deactivated': includeDeactivated,
      expand: expand?.join(','),
      include,
    },
  })
}
